import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./header.css";
import Logo from "../../../assets/img/Logo.png";

const PageHeader = () => {
  const location = useLocation();
  const isEV = location.pathname.includes("/ev");

  return (
    <div className="PageHeaderContainer">
      <div className="container">
        <div className="HeaderInnerContainer">
          <div className="HeaderLogo">
            <Link to="/">
              <img src={Logo} alt="Logo" />
            </Link>
            
          </div>
          <div className="HeaderContactInfo">
           <div className="ContactInfoContainer">
             <span className="ContactInfoMenu">
              <span className="ContactInfoMenuIcon">
                <i className="sb-mail" />
              </span>
              <span>admin@safebuy.com.au</span>
            </span>
            <span className="ContactInfoMenu">
              <span className="ContactInfoMenuIcon">
                <i className="sb-call" />
              </span>
              <span>03 8676 7692</span>
            </span>
           </div>
            <div className="evInspectionInfo">
              {!isEV ?  (
              <>
                <span className="evInspectionTitle">EV CAR INSPECTION BOOKING</span>
                <button
                  className="evButtonRipple"
                  onClick={() => window.open("/ev", "_blank")}
                >
                  Click Here
                </button>
              </>
              ):(
              <>
                <span className="evInspectionTitle">CONVENTIONAL CAR INSPECTION BOOKING</span>
                <button
                  className="mainButtonRipple"
                  onClick={() => window.open("/", "_blank")}
                >
                  Click Here
                </button>
              </>
            )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
